/**
 * Ask AI page-context parser — client copy. Keep in sync with the server
 * mirror at medicodio-nextgen-app-nodejs/src/lib/ask-ai/page-context.ts.
 * Pure and dependency-free. Returns null → the widget does not render.
 */
import type { PageContext } from '../types'

const EXCLUDED = /^\/(auth|q|403)(\/|$)/

const ADMIN_PREFIXES = [
  '/system-admin',
  '/engine-admin',
  '/client-admin',
  '/client-config',
  '/platform-config',
  '/prompt-config',
  '/operations-dashboard',
  '/clients',
  '/access',
]

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function parsePageContext(pathname: string): PageContext | null {
  const path = pathname.replace(/\/+$/, '') || '/'
  if (EXCLUDED.test(path)) return null

  const parts = path.split('/').filter(Boolean)

  if (parts[0] === 'workspace') {
    if (parts[1] === 'queue' && parts[2] === 'dispatch') {
      return { type: 'dispatch', slug: parts[3] }
    }
    if ((parts[1] === 'queue' || parts[1] === 'history') && parts[2] && UUID_RE.test(parts[2])) {
      return { type: 'encounter', slug: parts[2] }
    }
    return { type: 'queue' }
  }

  if (parts[0] === 'kb') return { type: 'kb', slug: parts[1] ?? 'overview' }
  if (parts[0] === 'search') return { type: 'search' }
  if (parts[0] === 'settings') return { type: 'settings' }

  if (ADMIN_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))) {
    return { type: 'admin', slug: parts[0] }
  }

  return { type: 'generic' }
}
